import axios from 'axios';

// import router from '@/router';
import auth from '@/utils/auth';

import {
  DELETE_TRANSACTION,
  DELETE_TRANSACTION_ERROR,
  DELETE_TRANSACTION_SUCCESS,

  DOWNLOAD_TRANSACTIONS,
  DOWNLOAD_TRANSACTIONS_ERROR,
  DOWNLOAD_TRANSACTIONS_SUCCESS,

  GET_TRANSACTION,
  GET_TRANSACTION_ERROR,
  GET_TRANSACTION_SUCCESS,

  GET_TRANSACTIONS,
  GET_TRANSACTIONS_ERROR,
  GET_TRANSACTIONS_SUCCESS,

  GET_ALL_TRANSACTIONS,
  GET_ALL_TRANSACTIONS_ERROR,
  GET_ALL_TRANSACTIONS_SUCCESS,

  GET_INVOICE,
  GET_INVOICE_ERROR,
  GET_INVOICE_SUCCESS,

  SAVE_TRANSACTION,
  SAVE_TRANSACTION_ERROR,
  SAVE_TRANSACTION_SUCCESS,

  DUPLICATE_TRANSACTION,
  DUPLICATE_TRANSACTION_ERROR,
  DUPLICATE_TRANSACTION_SUCCESS,

  CHANGE_DATE_TRANSACTION,
  CHANGE_DATE_TRANSACTION_ERROR,
  CHANGE_DATE_TRANSACTION_SUCCESS,

  MASS_DELETE_TRANSACTION,
  MASS_DELETE_TRANSACTION_ERROR,
  MASS_DELETE_TRANSACTION_SUCCESS,

  TRANSFER_TRANSACTION,
  TRANSFER_TRANSACTION_ERROR,
  TRANSFER_TRANSACTION_SUCCESS,

  GET_ACCOUNTS_WITH_TOTAL,
  GET_ACCOUNTS_WITH_TOTAL_ERROR,
  GET_ACCOUNTS_WITH_TOTAL_SUCCESS,

  CREATE_TRANSACTIONS,
  CREATE_TRANSACTIONS_ERROR,
  CREATE_TRANSACTIONS_SUCCESS,

  CREATE_PAYMENT_TRANSACTION,
  CREATE_PAYMENT_TRANSACTION_ERROR,
  CREATE_PAYMENT_TRANSACTION_SUCCESS,

  UPDATE_COOWNER_CONTACT,
  UPDATE_COOWNER_CONTACT_ERROR,
  UPDATE_COOWNER_CONTACT_SUCCESS,

  GET_TRANSACTION_USER,
  GET_TRANSACTION_USER_ERROR,
  GET_TRANSACTION_USER_SUCCESS,

} from './constants';

export default {
  async [DELETE_TRANSACTION]({ commit }, data) {
    try {
      commit(DELETE_TRANSACTION);
      await axios({
        url: `${process.env.API_URL}/api/transactions/${data.transactionID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_TRANSACTION_SUCCESS);
    } catch (err) {
      commit(DELETE_TRANSACTION_ERROR, err);
    }
  },

  async [DOWNLOAD_TRANSACTIONS]({ commit }, args) {
    try {
      commit(DOWNLOAD_TRANSACTIONS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/transactions/download`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          limit: '500',
          page: 0,
          sortField: args.sortField || 'date',
          sortDir: args.sortDir || 'DESC',
          filters: args.filters || null,
          // filters: 'account==ET4,date>2018-03-13,date<2018-03-16',
        },
      });
      commit(DOWNLOAD_TRANSACTIONS_SUCCESS, response.data);
    } catch (err) {
      commit(DOWNLOAD_TRANSACTIONS_ERROR, err);
    }
  },

  async [GET_TRANSACTION]({ commit }, transactionID) {
    try {
      commit(GET_TRANSACTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/${transactionID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_TRANSACTION_SUCCESS, response.data);
    } catch (err) {
      commit(GET_TRANSACTION_ERROR, err);
    }
  },

  async [GET_TRANSACTIONS]({ commit }, args) {
    try {
      commit(GET_TRANSACTIONS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/transactions`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          limit: args.limit || localStorage.pageLimit || '50',
          page: args.page || 0,
          sortField: args.sortField || 'date',
          sortDir: args.sortDir || 'DESC',
          // filters: args.filters || null,
          // filters: 'account==ET4,date>2018-03-13,date<2018-03-16',
        },
        paramsSerializer: (params) => {
          let queryString = new URLSearchParams(params).toString();
          // Manually append filters to avoid URL encoding
          if (args.filters) {
            queryString += `&filters=${args.filters}`;
          }
          return queryString;
        },
      });
      commit(GET_TRANSACTIONS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_TRANSACTIONS_ERROR, err);
    }
  },

  async [GET_ALL_TRANSACTIONS]({ commit }, args) {
    try {
      commit(GET_ALL_TRANSACTIONS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/transactions`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          limit: args.limit || args.total,
          page: args.page || 1,
          sortField: args.sortField || 'date',
          sortDir: args.sortDir || 'DESC',
          filters: args.filters || null,
          // filters: 'account==ET4,date>2018-03-13,date<2018-03-16',
        },
      });
      commit(GET_ALL_TRANSACTIONS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ALL_TRANSACTIONS_ERROR, err);
    }
  },

  async [GET_INVOICE]({ commit }, data) {
    try {
      commit(GET_INVOICE);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/invoice`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(GET_INVOICE_SUCCESS, response.data);
    } catch (err) {
      commit(GET_INVOICE_ERROR, err);
    }
  },

  async [SAVE_TRANSACTION]({ commit }, data) {
    const { transaction, rowIndex } = data;
    try {
      commit(SAVE_TRANSACTION);
      let url = `${process.env.API_URL}/api/transactions`;
      let method = 'POST';
      if (transaction.transactionID) {
        url = `${url}/${transaction.transactionID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data: transaction,
      });
      commit(SAVE_TRANSACTION_SUCCESS, { transaction: response.data, rowIndex });
    } catch (err) {
      commit(SAVE_TRANSACTION_ERROR, err);
    }
  },

  async [DUPLICATE_TRANSACTION]({ commit }, data) {
    try {
      commit(DUPLICATE_TRANSACTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/duplicate`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(DUPLICATE_TRANSACTION_SUCCESS, response.data);
    } catch (err) {
      commit(DUPLICATE_TRANSACTION_ERROR, err);
    }
  },

  async [CHANGE_DATE_TRANSACTION]({ commit }, data) {
    try {
      commit(CHANGE_DATE_TRANSACTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/change-date`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(CHANGE_DATE_TRANSACTION_SUCCESS, response.data);
    } catch (err) {
      commit(CHANGE_DATE_TRANSACTION_ERROR, err);
    }
  },

  async [MASS_DELETE_TRANSACTION]({ commit }, data) {
    try {
      commit(MASS_DELETE_TRANSACTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/delete`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(MASS_DELETE_TRANSACTION_SUCCESS, response.data);
    } catch (err) {
      commit(MASS_DELETE_TRANSACTION_ERROR, err);
    }
  },

  async [TRANSFER_TRANSACTION]({ commit }, data) {
    try {
      commit(TRANSFER_TRANSACTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/transfer`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(TRANSFER_TRANSACTION_SUCCESS, response.data);
    } catch (err) {
      commit(TRANSFER_TRANSACTION_ERROR, err);
    }
  },

  async [GET_ACCOUNTS_WITH_TOTAL]({ commit }, args) {
    try {
      commit(GET_ACCOUNTS_WITH_TOTAL);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/accounts-with-total`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_ACCOUNTS_WITH_TOTAL_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ACCOUNTS_WITH_TOTAL_ERROR, err);
    }
  },

  async [CREATE_TRANSACTIONS]({ commit }, { syndicateID, payers }) {
    try {
      commit(CREATE_TRANSACTIONS);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/drd`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data: {
          syndicateID,
          payers,
        },
      });
      commit(CREATE_TRANSACTIONS_SUCCESS, response.data);
    } catch (err) {
      commit(CREATE_TRANSACTIONS_ERROR, err);
    }
  },

  async [CREATE_PAYMENT_TRANSACTION]({ commit }, data) {
    try {
      commit(CREATE_PAYMENT_TRANSACTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/create-payment`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(CREATE_PAYMENT_TRANSACTION_SUCCESS, response.data);
    } catch (err) {
      commit(CREATE_PAYMENT_TRANSACTION_ERROR, err);
    }
  },

  async [UPDATE_COOWNER_CONTACT]({ commit }, data) {
    try {
      commit(UPDATE_COOWNER_CONTACT);
      const response = await axios({
        url: `${process.env.API_URL}/api/transactions/connect/coowner/user`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(UPDATE_COOWNER_CONTACT_SUCCESS, response.data);
    } catch (err) {
      commit(UPDATE_COOWNER_CONTACT_ERROR, err);
    }
  },

  async [GET_TRANSACTION_USER]({ commit }, data) {
    try {
      commit(UPDATE_COOWNER_CONTACT);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicate/${data}/transaction-users`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(GET_TRANSACTION_USER_SUCCESS, response.data);
    } catch (err) {
      commit(GET_TRANSACTION_USER_ERROR, err);
    }
  },

};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Transactions/actions.js